import { useContext, useTransition } from "react";
import { Modal, Form, Input, Button } from "antd";
import { User, Lock } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

import logo from "/images/logo.webp";

import { AppContext } from "../../App";

export const Login = ({ children }) => {
  const [form] = Form.useForm();

  const [isPending, startTransition] = useTransition();

  const { accessToken, setAccessToken } = useContext(AppContext);

  const onFinishHandler = (values) => {
    startTransition(async () => {
      try {
        const response = await axios.post(
          `${import.meta.env.VITE_API_BOOKING}/api/auth/login`,
          {
            email: values.email,
            password: values.password,
          },
        );

        if (response.data.accessToken) {
          localStorage.setItem("accessToken", response.data.accessToken);
          setAccessToken(response.data.accessToken);
        }
      } catch (err) {
        console.log(err);
        toast.error(err?.response?.data?.error);
      }
    });
  };

  if (accessToken) return <>{children}</>;

  return (
    <Modal open={true} centered closable={false} width={400} footer={null}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 24,
        }}
      >
        <img style={{ width: 200 }} src={logo} alt="MedArmor" />
      </div>
      <h3 style={{ fontSize: 14, fontWeight: 400, marginBottom: 24 }}>
        Nhập email và mật khẩu bên dưới để đăng nhập vào tài khoản của bạn
      </h3>
      <Form layout="vertical" name="login" form={form}>
        <Form.Item
          name="email"
          label="Email hoặc số điện thoai"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập email hoặc số điện thoại!",
            },
          ]}
        >
          <Input
            prefix={<User size={14} />}
            placeholder="Nhập email hoặc số điện thoai"
          />
        </Form.Item>
        <Form.Item
          name="password"
          label="Mật khẩu"
          rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
        >
          <Input
            prefix={<Lock size={14} />}
            type="password"
            placeholder="Nhập mật khẩu"
          />
        </Form.Item>
      </Form>
      <Button
        type="primary"
        loading={isPending}
        onClick={() => form.validateFields().then(onFinishHandler)}
        style={{ width: "100%", marginTop: 12 }}
      >
        Đăng nhập
      </Button>
    </Modal>
  );
};
